<template>
  <div class="user-manage-constructor main-body">
    <div class="button-search-body">
      <div class="search-body">
        <div class="button-body">
          <ButtonList 
            :list="buttonList"
            :target="buttonTarget"
          />
        </div>
        <el-input 
          v-model="listQuery.taskName"
          placeholder="任务名称"
          size="small"
        />
        <el-button 
          icon="Search"
          size="small"
          type="primary"
          @click="selectList"
          :loading="listQuery.loading"
        >查询</el-button>
      </div>
    </div>
    <div class="table-body">
      <TableCom
        :tableList="tableList"
        :tableProps="tableProps"
        :cell-class-name="cellClassName"
      ></TableCom>
    </div>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.length"
      />
    </div>
    <EditTargetCom
      v-if="editTarget"
      :target="editTarget"
      :title="title"
      @close="editTargetClose"
      @refresh="selectList" />
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue'
import { isNull, dayjs, message } from '@/utils/js/initVariable'
import TableCom from '@/components/TableCom'
import Pagination from '@/components/Pagination'
import ButtonList from '@/components/ButtonList'
import {
  ElLoading, ElMessageBox, ElImageViewer,
} from 'element-plus'
import { queryRegionDirectoryList, deleteRegionDirectory } from '@/api/RegionDirectoryApi';

import EditTargetCom from './component/edit';

import {
  getAllTasks, pauseTask, resumeTask, deleteTask,
} from '@/api/UserWorkspaceApi';

// props
const props = defineProps({
  
})
// emit
const emit = defineEmits([
  
])

const editTarget = ref(undefined)
const title = ref('')
const addTaskFn = (target, button, loadFn) => {
  title.value = '新增任务'
  editTarget.value = Object.assign({}, {
    ...target,
  })
  loadFn()
}
const editTargetClose = () => {
  editTarget.value = undefined;
  title.value = undefined;
}

const searchFun = (target, button, loadFn) => {
  selectList()
  loadFn()
}
const pauseTaskFn = (target, button, loadFn)=>{
  ElMessageBox.confirm(
    '是否暂停当前任务？',
    '暂停任务',
    {
      confirmButtonText: '暂停',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(()=>{
    pauseTask(target.id).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1)
        selectList()
      }
    })
  }).catch((err) => {
    console.log(err)
  }).finally(()=>{
    loadFn && loadFn()
  })
}
const resumeTaskFn = (target, button, loadFn)=>{
  ElMessageBox.confirm(
    '是否恢复当前任务？',
    '恢复任务',
    {
      confirmButtonText: '恢复',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(()=>{
    resumeTask(target.id).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1)
        selectList()
      }
    })
  }).catch((err) => {
    console.log(err)
  }).finally(()=>{
    loadFn && loadFn()
  })
}
const deleteTaskFn = async(target, button, loadFn) => {
  ElMessageBox.confirm(
    '是否删除当前任务？',
    '删除任务',
    {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(()=>{
    deleteTask(target.id).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1)
        selectList()
      }
    })
  }).catch((err) => {
    console.log(err)
  }).finally(()=>{
    loadFn && loadFn()
  })
}

const cellClassName = ({ row, column, rowIndex, columnIndex, })=>{
  console.log(row, column, rowIndex, columnIndex,);
  if(column['property'] == 'statusStr'){
    return `status-cell status-${row['status']}-cell`;
  }
}

// 需要序号可添加
const tableNumber = (number)=>{
  return (listQuery.page-1) * listQuery.length + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, },
  { label: 'ID', prop: 'id', },
  { label: '任务名称', prop: 'taskName', },
  { label: '任务描述', prop: 'taskDesc', },
  { label: '任务类型', prop: 'spanType', },
  { label: '执行进度', fun: (target)=>{
      return `${target['executedCount']}/${target['executeCount']}`;
    },
  },
  { label: '首次执行时间', prop: 'firstExecuteTime', },
  { label: '状态', prop: 'statusStr', },
  { label: '操作', 
    buttonList: [
      { name: '恢复', icon: 'el-SwitchButton', fun: resumeTaskFn, type: 'primary',
        showFun: (target)=>{
          return target['status'] === 'PAUSED';
        }
      },
      { name: '暂停', icon: 'el-SwitchButton', fun: pauseTaskFn, type: 'warning',
        showFun: (target)=>{
          return target['status'] === 'ACTIVE';
        }
      },
      { name: '删除', icon: 'el-Delete', fun: deleteTaskFn, type: 'danger'},
    ]
  }
])


const buttonTarget = ref({});
const buttonList = ref([
  // { name: '查询', icon: 'el-Search', type: 'primary', fun: searchFun },
  { name: '新增任务', icon: 'el-Plus', type: 'primary', fun: addTaskFn },
])

const tableList = ref([])
let total = ref(0),
    listQuery = reactive({
      page: 1,
      length: 20,
      taskName: '',
      loading: false,
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  // console.log(listQuery);
  listQuery.loading = true;
  getAllTasks({
    ...listQuery,
    pager: listQuery,
  }).then(res=>{
    if(res.data.code == 1004){
      tableList.value = res.data.dataList;
      total.value = res.data.totalCount;
    }
  }).catch(err=>{
    console.log(err)
  }).finally(()=>{
    listQuery.loading = false;
  })
}

// 组件挂载前
onBeforeMount(()=>{

})
// 组件挂载后
onMounted(()=>{
  selectList()
})
// 组件更新后
onUpdated(()=>{

})
// 组件销毁后
onUnmounted(()=>{

})

</script>

<style lang='less'>
.status-cell{
  color: rgb(255, 255, 255);
  .content-div{
    width: max-content !important;
    border-radius: 5px;
    background-color: rgb(218, 23, 23);
    padding: 0 10px;
    margin: 0 auto;
  }
}
.status-cell.status-PAUSED-cell{
  .content-div{
    background-color: rgb(230, 162, 60);
  }
}
.status-cell.status-ACTIVE-cell{
  .content-div{
    background-color: rgb(36, 87, 234);
  }
}
.status-cell.status-FINISHED-cell{
  .content-div{
    background-color: rgb(30, 205, 108);
  }
}
</style>

<style lang='less' scoped>
.user-manage-constructor {
  padding: 10px;
  --h3Height: 30px;
}
</style> 